import { api } from './api';
import type { Correction, FailureCategory } from '@sr-test-wizard/shared';

export interface RecognitionEvalResult {
  exact: {
    total: number;
    correct: number;
    collisions: Array<{ alias: string; expected: string; got: string }>;
  };
  semantic: {
    ran: boolean;
    total: number;
    correct: number;
    misses: Array<{ concept: string; got: string | null; score: number | null }>;
    note?: string;
  };
}

export interface EvalSummary {
  conceptCount: number;
  taggableCount: number;
  corrections: Record<string, number>;
}

/** /api/corrections + /api/eval - the eval loop's read surfaces. */
export const evalApi = {
  listCorrections: (filter?: { runId?: string; category?: FailureCategory }) => {
    const qs = new URLSearchParams();
    if (filter?.runId) qs.set('runId', filter.runId);
    if (filter?.category) qs.set('category', filter.category);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return api.get<Correction[]>(`/api/corrections${suffix}`);
  },
  correctionsSummary: () => api.get<Record<string, number>>('/api/corrections/summary'),
  summary: () => api.get<EvalSummary>('/api/eval/summary'),
  recognition: () => api.get<RecognitionEvalResult>('/api/eval/recognition'),
};
